<template>
  <div>
    <div
      v-if="loading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Loan Analysis ready...</h3>
        </div>
      </div>
    </div>
    <div v-else-if="statCards !== null" class=" row">
      <!-- <div class="col-xl-4 col-lg-6 col-12 px--5">
        <CCard
          :text="'Total Amount Waived'"
          :value="statCards.total_amounts_waived"
          :cardImg="transactionIcon"
          :bgColor="'#FB0800'"
        />
      </div>
      <div class="col-xl-4 col-lg-6 col-12 px--5">
        <CCard
          :text="'Total Amount Repaid'"
          :value="statCards.total_amounts_repaid"
          :cardImg="transactionIcon"
          :bgColor="activeColor"
        />
      </div>
      <div class="col-xl-4 col-lg-6 col-12 px--5">
        <CCard
          :text="'Total Loan Remain Balance'"
          :value="statCards.total_loan_remmain_balance"
          :cardImg="transactionIcon"
          :bgColor="'red'"
        />
      </div>
      <div class="col-xl-4 col-lg-6 col-12 px--5">
        <CCard
          :text="'Total Amount Disbursed'"
          :value="statCards.total_amounts_disbursed"
          :cardImg="transactionIcon"
          :bgColor="'#FBc108'"
        />
      </div>
      <div class="col-xl-4 col-lg-6 col-12 px--5">
        <CCard
          :text="'Total Active Loan Remain Balance'"
          :value="statCards.total_active_loan_remmain_balance"
          :cardImg="transactionIcon"
          :bgColor="'red'"
        />
      </div>
      <div class="col-xl-4 col-lg-6 col-12 px--5">
        <CCard
          :text="'Recovery Account Balance'"
          :value="statCards.recovery_account_balance"
          :cardImg="transactionIcon"
          :bgColor="activeColor"
        />
      </div>
      <div class="col-xl-4 col-lg-6 col-12 px--5">
        <CCard
          :text="'Total Over Due Loan Remain Balance'"
          :value="statCards.total_over_due_loan_remmain_balance"
          :cardImg="transactionIcon"
          :bgColor="'#FB0800'"
        />
      </div> -->
    </div>

    <!-- <disbursement-stat /> -->
    <collection-stat />

    <review-stat />
  </div>
</template>

<script>
import CCard from "@/components/CCard";
import ApiService from "@/services/api.service";
import transactionIcon from "@/assets/images/transaction-icon.png";
export default {
  name: "LoanAnalysis",
  components: {
    CCard
  },
  computed: {
    permissions() {
      let permissions = this.$tore.getters.permissions;
      return permissions;
    }
  },
  data() {
    return {
      activeColor: "#2CB858",
      dangerColor: "#FBC108",
      primaryColor: "#242452",
      textColor: "#001833",
      transactionIcon,
      valueColor: "#001833",
      statCards: null,
      loading: true
    };
  },
  methods: {
    async getData() {
      try {
        const response = await ApiService.get("loan/instant/loan-analysis");
        console.log(response);
        this.statCards = response.data.data;
        this.loading = false;
      } catch (error) {
        console.log("Error.response");
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped></style>
